import { takeLatest, take, select, put, race, call } from 'redux-saga/effects';
import get from 'lodash/get';

import { actions as checkInsuranceEligibilityActions } from '../requests/check-insurance-eligibility';
import {
  selectProgressCareUserId,
  selectProgressScheduleLocationId,
  selectProgressService,
} from '../selectors';
import { actions as latestCheckInsuranceActions } from '../requests/latest-check-insurance-req';
import { insuranceErrorModalActions } from '../handle-insurance-error-modal';
import { appointmentProgressActions } from '../progress-types';
import {
  redirectToConsentForm,
  redirectToVisitDetails,
} from '../../../utils/appointments/redirect-utils';
import createConsts from '../../../utils/redux/consts';
import { targetUserIdSelector } from '../../context/selectors';
import * as succeed from '../../ui/success';
import { checkState } from '../../../utils/checkState';

function* handleCheckInsuranceWorker({ payload }) {
  const {
    dob,
    city,
    state,
    lastName,
    address1,
    address2,
    memberId,
    firstName,
    postalCode,
    phoneNumber,
    groupNumber,
    currentHealthPlan,
    isPrimarySubscriber,
    isOfficeOrVirtualVisit,
    checkInsuranceInProfile,
  } = payload;

  const careUserId = yield select(selectProgressCareUserId);
  const targetUserId = yield select(targetUserIdSelector);
  const service = yield select(selectProgressService);
  const locationId = yield select(selectProgressScheduleLocationId);

  const safePayload = {
    memberId,
    payerId: currentHealthPlan.id,
    userId: careUserId || targetUserId,
    ...(locationId && { locationId }),
    ...(service && service.id && { serviceId: service.id }),
    ...(groupNumber &&
      groupNumber.trim() && { groupNumber: groupNumber.trim() }),
    ...(!isPrimarySubscriber && {
      primarySubscriber: {
        firstName,
        lastName,
        dob,
        phoneNumber,
        address1,
        address2,
        city,
        postalCode,
        ...(state && { state: checkState(state) }),
      },
    }),
  };

  yield put(checkInsuranceEligibilityActions.send(safePayload));

  const { success, reject } = yield race({
    success: take(checkInsuranceEligibilityActions.succeed),
    reject: take([
      checkInsuranceEligibilityActions.rejected,
      checkInsuranceEligibilityActions.errorEncountered,
    ]),
  });

  if (reject && !reject.payload) {
    yield put({
      type: createConsts('ui', 'error', ['UPDATE']).UPDATE,
      payload: { id: 'errors.longRequest.502.504' },
    });
  }

  if (reject && reject.payload) {
    const handledErrorEntity = get(reject.payload, 'error.meta');

    if (handledErrorEntity) {
      yield put(insuranceErrorModalActions.open({ ...handledErrorEntity }));
    } else {
      yield put({
        type: createConsts('ui', 'error', ['UPDATE']).UPDATE,
        payload: { id: 'errors.common' },
      });
    }
  }

  if (success) {
    if (checkInsuranceInProfile) {
      yield put({
        type: succeed.consts.UPDATE,
        payload: { id: 'appointments.form.insuranceDetails,success' },
      });
    } else {
      yield put(
        appointmentProgressActions.setInsuranceEligibility({
          ...success.payload,
        }),
      );
      yield put(latestCheckInsuranceActions.clear());
      yield put(checkInsuranceEligibilityActions.clear());
      if (isOfficeOrVirtualVisit) {
        yield call(redirectToConsentForm);
      } else {
        yield call(redirectToVisitDetails);
      }
    }
  }
}

export default function* checkInsuranceEligibilitySaga() {
  yield takeLatest(
    checkInsuranceEligibilityActions.init,
    handleCheckInsuranceWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/check-insurance-saga.js